module.exports = __webpack_public_path__ + "img/login_title.7c1015d4.png";